export const portfolioData = [
    {
      "_id": "5f011c5b90e9e00007825ea8",
      "order": 5,
      "slug": "experiences",
      "title": "experiences",
      "content": "",
      "metadata": {
        "description": "Professional and academic",
        "title": "Experience",
        "professional": [
          {
            "year": "03.2022 - 05.2023",
            "title": "Jr. Backend Developer",
            "content": "Starter Nepal Pvt Ltd"
          }
        ],
        "academic": [
          {
            "year": "2017 - 2022",
            "title": "Bachelor of Science in Computer Science and Information Technology (BSc. CSIT)",
            "content": "National College of Computer Studies (NCCS)"
          },
          {
            "year": "2017",
            "title": "Plus Two(+2)",
            "content": "Prime College"
          },
          {
            "year": "2015",
            "title": "School Leaving Certificate(S.L.C)",
            "content": "BernHardt Higher Secondary School"
          }
        ]
      }
    },
    {
      "_id": "5f01fd8350006f00083229f5",
      "order": 4,
      "slug": "description",
      "title": "description",
      "content": "",
      "metadata": {
        "pres_second": " My journey so far has been in crafting robust APIs and manipulating data. When I'm not immersed in building application, writing lines of code, I tend to explore new technologies and try integrating them along my works.",
        "pres_first": "I'm a Python Developer with a strong focus on backend API creation and data ETL (Extract, Transform, Load) processes. Graduated in Bachelor of Science in Computer Science and Information Technology (BSc.CSIT).",
        "pres_title": "Who am I ?",
        "description": "Hope to know you after",
        "title": "About Me"
      }
    },
    {
      "_id": "5f01fee250006f00083229f7",
      "order": 3,
      "slug": "user-data",
      "title": "user-data",
      "content": "",
      "metadata": {
        "name": "Yubraj Maharjan",
        "status": "Backend Developer",
        "email": "yubmaharjan322@gmail.com",
        "phone": "+977 9849784723",
        "city": "Kathamdu, Nepal",
        "lang": "Nepali, English",
        "photo": "photo.jpg"
      }
    },
    {
      "_id": "5f0204d6ea1bf90007ad680f",
      "order": 2,
      "slug": "links",
      "title": "links",
      "content": "",
      "metadata": {
        "linkedin": "https://www.linkedin.com/in/yub-maharjan-7b4b9021b/",
        "github": "https://github.com/Yub-0"
      }
    },
    {
      "_id": "5f02127c1b1b930007b5896c",
      "order": 1,
      "slug": "skills",
      "title": "skills",
      "content": "",
      "metadata": {
        "items": [
          {
            "title": "Python",
            "img": "python.png"
          },
          {
            "title": "Django",
            "img": "django.png"
          },
          {
            "title": "Django Rest Framework",
            "img": "drf.png"
          },
          {
            "title": "PostgreSQL",
            "img": "postgres.png"
          },
          {
            "title": "JavaScript",
            "img": "js.png"
          },
          {
            "title": "VueJS",
            "img": "vuejs.png"
          },
          {
            "title": "Linux",
            "img": "linux.png"
          },
          {
            "title": "Git/Github",
            "img": "Octocat.png"
          },
          {
            "title": "Nginx",
            "img": "nginx.png"
          }
        ],
        "title": "Skills",
        "description": "Here is my armament"
      }
    },
    {
      "_id": "5f023635b7e93b000741a246",
      "order": 0,
      "slug": "projects",
      "title": "projects",
      "content": "",
      "metadata": {
        "items": [
          {
            "company":'t',
            "title": "Pharmacy Management System (At Starter Nepal)",
            "content": "Web App for pharmacy to keep track of their medicine sales and stock. Features include sales report generation, patient management and laboratory.<br><br>Link : <a href='https://hmsdemo.starternepal.com/#/'>https://hmsdemo.starternepal.com/#/</a>",
            "link": "https://hmsdemo.starternepal.com/#/",
            "image": "pms.png",
            "tag": "Software",
            "color": "blue",
            "date": "2022-08-10"
          },
          {
            "company":'t',
            "title": "Restaurant Management System (At Starter Nepal)",
            "content": "Web App for restaurants to manage their day to day work. Has an inventory management features along with report generation.<br><br>Link : <a href='https://rmsdemo.starternepal.com/#/'>https://rmsdemo.starternepal.com/#/</a>",
            "link": "https://rmsdemo.starternepal.com/#/",
            "image": "rms.png",
            "tag": "Software",
            "color": "orange",
            "date": "2022-12-10"
          }
        ],
        "title": "My projects",
        "description": "This is my story"
      }
    }
  ]